import {
    SETTINGS_REQUEST,
    SETTINGS_SUCCESS,
    SETTINGS_FAILURE,
    SETTING_ADD_REQUEST,
    SETTING_ADD_SUCCESS,
    SETTING_ADD_FAILURE,
    SETTING_UPDATE_REQUEST,
    SETTING_UPDATE_SUCCESS,
    SETTING_UPDATE_FAILURE,
    SETTING_DELETE_REQUEST,
    SETTING_DELETE_SUCCESS,
    SETTING_DELETE_FAILURE
} from '../actions';

export const SETTINGS_INITIAL_STATE = {
    isFetching: false,
    data: [],
    error: null
};

const settingsReducers = {
    [SETTINGS_REQUEST]: (state) => {
        return {...state, isFetching: true, error: null};
    },
    [SETTINGS_SUCCESS]: (state, {res}) => {
        return {...state, ...res, isFetching: false, error: null};
    },
    [SETTINGS_FAILURE]: (state, {error}) => {
        return {...state, isFetching: false, error};
    },
    [SETTING_ADD_SUCCESS]: (state, {res}) => {
        const settings = [...state.data];
        const setting = settings.find(i => i.id === res.reference_id);
        setting.config = res;

        return {...state, data: settings, isFetching: false, error: null};
    },
    [SETTING_ADD_FAILURE]: (state, {error}) => {
        return {...state, isFetching: false, error};
    },
    [SETTING_UPDATE_SUCCESS]: (state, {res}) => {
        const settings = [...state.data];
        const setting = settings.find(i => i.id === res.reference_id);
        setting.config = res;

        return {...state, data: settings, isFetching: false, error: null};
    },
    [SETTING_UPDATE_FAILURE]: (state, {error}) => {
        return {...state, isFetching: false, error};
    },
    [SETTING_DELETE_SUCCESS]: (state, {reference}) => {
        const settings = [...state.data];
        const setting = settings.find(i => i.id === reference);
        setting.config = null;

        return {...state, data: settings, isFetching: false, error: null};
    },
    [SETTING_DELETE_FAILURE]: (state, {error}) => {
        return {...state, isFetching: false, error};
    }
};

export default function settings(state = SETTINGS_INITIAL_STATE, action) {
    let reducer = settingsReducers[action.type] || (state => state);
    return reducer(state, action);
}


// WEBPACK FOOTER //
// ./resources/assets/js/reducers/engineer-settings.js